(() => {
  const sections = document.querySelectorAll('.collection-hero-pflanzenmax');

  sections.forEach((section) => {
    const description = section.querySelector('.collection-hero-pflanzenmax__description');
    const toggle = section.querySelector('.collection-hero-pflanzenmax__description-toggle');

    if (!description || !toggle) return;

    if (description.dataset.collectionDescriptionToggle === 'true') return;

    const textLength = description.textContent?.trim().length ?? 0;
    if (textLength < 280) {
      description.classList.remove('collection-hero-pflanzenmax__description--clamped');
      toggle.setAttribute('hidden', true);
      return;
    }

    description.dataset.collectionDescriptionToggle = 'true';
    const moreLabel = window.themeStrings?.readMore ?? 'Weiterlesen';
    const lessLabel = window.themeStrings?.readLess ?? 'Weniger anzeigen';
    let expanded = false;

    description.classList.add('collection-hero-pflanzenmax__description--toggle-ready');

    const applyState = () => {
      description.classList.toggle('collection-hero-pflanzenmax__description--clamped', !expanded);
      toggle.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? lessLabel : moreLabel;
    };

    toggle.addEventListener('click', () => {
      expanded = !expanded;
      applyState();
    });

    applyState();
  });
})();
